import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ProfileSms } from "@/components/profiles/profile-sms";
import { PAGE_SIZE_OPTIONS } from "@/constants/pagination";

const ProfileSmsPage = () => {
  return <ProfileSms />;
};

export const Route = createFileRoute("/_private/profiles/$id/sms/")({
  component: ProfileSmsPage,
  validateSearch: z.object({
    page: z.coerce.number().int().min(1).optional().catch(undefined),
    limit: z.coerce
      .number()
      .refine((value) => {
        return PAGE_SIZE_OPTIONS.some((option) => {
          return option === value;
        });
      })
      .optional()
      .catch(undefined),
  }),
});
